import { themeColors } from "@/styles"
import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	chip: {
		backgroundColor: themeColors.colors.info[100],
		borderRadius: "0.5rem",
		width: "4.5rem",
		height: "1.5rem"
	}
}))

export default useStyles